const translations = {
  ja: {
    lang: "EN",  // label shown on the button (switches to the other lang)
    nav: {
      about: "About",
      timeline: "Timeline",
      projects: "Projects",
      skills: "Skills",
      contact: "Contact",
    },
    banner: "バックエンド / ML / セキュリティ分野のインターンを探しています",
    bannerClose: "閉じる",
    backToTop: "トップへ戻る",

    hero: {
      badge: "インターン先を探しています",
      description: "大学3年生（情報系）｜バックエンドエンジニア志望｜サイバーセキュリティ × 機械学習に興味",
      yearBadge: "3年生",
      locationBadge: "大阪",
      projectsBtn: "Projects →",
      contactBtn: "Contact",
    },

    about: {
      label: "ABOUT",
      heading: "自己紹介",
      subheading: "Backend / Security / ML に興味のある近大生",
      paragraphs: [
        "2024年に近畿大学 情報学部 情報学科へ入学した学部3年です。小学生の頃からe-kagakuでプログラミングやデータ分析に触れ、現在はバックエンドエンジニア、サイバーセキュリティ、機械学習に関心を持っています。",
        "チーム開発でカラオケ向け音域解析アプリ「Pitch Scout」を開発中で、バックエンドとMLモデルを担当しています。直近の「近大ハッカソン2025」ではKindai Innovation Awardを受賞し、KC3Hackなどの外部イベントでも開発経験を積んでいます。",
        "英語力の強化も継続して取り組んでいます。現在はe-kagakuで小中高生にプログラミングを指導しながら、実務経験やプロダクト運用の知識を得るため、バックエンド・セキュリティ・AI/ML分野のインターン先を探しています。",
      ],
      cards: [
        { label: "学歴",   value: "近畿大学 情報学部" },
        { label: "所在地", value: "大阪" },
        { label: "興味",   value: "Security / ML / Backend" },
        { label: "状況",   value: "インターンシップ希望" },
        { label: "受賞",   value: "Kindai Innovation Award '25" },
      ],
    },

    timeline: {
      label: "TIMELINE",
      heading: "活動履歴",
      subheading: "これまでの学習・開発実績",
      items: [
        { year: "2015.10", title: "プログラミング学習開始",          desc: "e-kagakuに入会し、e-gadgetを活用したプログラミングの基礎とモノづくりを学び始める。" },
        { year: "2019.xx", title: "琵琶湖環境プロジェクト参加",       desc: "e-kagakuにて環境データの収集・分析プロジェクトに参加。" },
        { year: "2020.xx", title: "成層圏探査とデータ分析",           desc: "百均アイテムとMATLABを活用した成層圏探査プロジェクトに参加。ハードウェアとデータ分析を経験。" },
        { year: "2024.03", title: "e-kagaku 卒業",                   desc: "基礎・応用課程を修了。Arduino, VBA, MATLABを用いた機械学習を習得。" },
        { year: "2024.04", title: "近畿大学 入学",                   desc: "情報学部 情報学科へ入学。より専門的なCS・情報工学の学習を開始。" },
        { year: "2024.05", title: "e-kagaku サポーター就任",          desc: "後進の育成のため、サポーターとして活動をスタート。" },
        { year: "2025.12", title: "近大ハッカソン 受賞",              desc: "学内ハッカソンにて『Kindai Innovation Award』を受賞。" },
        { year: "2026.02", title: "KC3Hack 参加 / Pitch Scout 開発", desc: "関西最大の学生ハッカソン KC3Hack に参加。5人チームでカラオケ音域解析アプリ『Pitch Scout』を開発し、バックエンドの音声処理パイプラインと地声/裏声分類MLモデルを担当。" },
        { year: "2026.05", title: "技育博 参加",                     desc: "サポーターズ主催の学生エンジニア向け技術展示イベント『技育博』に参加（5/30）。チーム開発プロダクトの展示・他大学/他チームの学生エンジニアとの交流を通じて、開発手法やプロダクト設計のフィードバックを得る。" },
        { year: "2026.06", title: "58Hack 参加 / OB賞受賞",          desc: "ハッカソン『58Hack』に参加（6/14）。OB賞を受賞。" },
        { year: "2026.08", title: "クリエーションライン 5Daysインターン", desc: "クリエーションライン株式会社の5Daysサマーインターンシップに参加（8/3〜8/7）。" },
        { year: "2026.08", title: "PR TIMES ハッカソン 最優秀チーム賞", desc: "PR TIMES 主催のハッカソンに参加（8/12〜8/14）。3人チームでPR企画レコメンドサービス『Team Empo』を開発し、最優秀チーム賞を受賞。" },
        { year: "2026.08", title: "ワークスアプリケーションズ 6Daysインターン", desc: "株式会社ワークスアプリケーションズの6Daysインターンシップに参加（8/23〜8/28）。" },
        { year: "2026.09", title: "アイテック阪急阪神 5Daysインターン", desc: "アイテック阪急阪神株式会社の5Daysインターンシップに参加（8/31〜9/4）。" },
      ],
    },

    projects: {
      label: "PROJECTS",
      heading: "プロジェクト",
      subheading: "実際に設計・実装した、または現在開発中のプロダクト",
      accordionOpen: "閉じる",
      accordionClosed: "詳細を見る",

      pitchScout: {
        subtitle: "AI-Powered Karaoke Song Recommender",
        description: "声を録音するだけでAIが音域を分析し、自分に合ったカラオケ曲をレコメンドするWebアプリ。5人チームで開発。バックエンドの音声処理パイプラインと機械学習モデルを主に担当。",
        roleLabel: "担当・取り組み",
        roleBadge: "バックエンド / ML担当",
        tasks: [
          "MelBandRoformersによるボーカル自動分離パイプライン構築",
          "WORLD(pyworld)によるF0/スペクトル特徴抽出",
          "AP/HNRゲート + RandomForest による地声/裏声分類モデル設計",
          "FastAPIでのバックエンドAPI設計・実装",
          "DeepFilterNet + Silero VAD による多段ノイズ除去",
        ],
        techLabel: "バックエンド技術スタック",
        techStack: [
          { layer: "Web API",    tech: "FastAPI 0.115 + uvicorn" },
          { layer: "F0抽出",     tech: "WORLD (pyworld)" },
          { layer: "音源分離",   tech: "MelBandRoformers (audio-separator)" },
          { layer: "ノイズ除去", tech: "DeepFilterNet3 + Silero VAD" },
          { layer: "ML判定",     tech: "scikit-learn RandomForest" },
          { layer: "音声処理",   tech: "soundfile / numpy / ffmpeg" },
          { layer: "楽曲DB",     tech: "SQLite（~5000曲 / ~850アーティスト）" },
          { layer: "ユーザーDB", tech: "Supabase (PostgreSQL)" },
        ],
        pipelineLabel: "音声解析パイプライン",
        pipeline: [
          { label: "音声入力",         color: "#818cf8" },
          { label: "ffmpeg変換" },
          { label: "MelBandRoformers" },
          { label: "DeepFilterNet" },
          { label: "WORLD抽出" },
          { label: "ML判定" },
          { label: "楽曲推薦",         color: "#34d399" },
        ],
        detailsLabel: "実装の工夫",
        details: [
          { title: "Gate-first Hybrid 地声/裏声判定", desc: "AP（非周期性指標）と HNR（調波対雑音比）をゲート条件とし、両条件成立で裏声確定、片側のみは RandomForest にフォールバックする 2 層ハイブリッド判定。F0 < 330Hz は常に地声確定とするハード下限も設定。" },
          { title: "WORLD 特徴量 + 20次元セグメント集約", desc: "pyworld で F0 / スペクトル包絡(SP) / 非周期性指標(AP) を抽出し、フレーム音響特徴 9 次元（f0, ap_mean, hnr, sp_tilt, h1_h2, hcount 等）からセグメント特徴 20 次元を集約。StandardScaler + RandomForest Pipeline で胸声信頼度を推定。" },
          { title: "多段ノイズ除去パイプライン",       desc: "MelBandRoformers 分離後の残留ノイズを、① DeepFilterNet3（NN ベース、20dB 減衰上限）、② Silero VAD（歌声スコア < 0.3 を除外、裏声の過剰除去防止の安全弁付き）、③ noisereduce の 3 段で対策。" },
          { title: "3 層セキュリティ検証",             desc: "拡張子 → MIME Type → マジックバイト（WAV は RIFF+WAVE 二重確認）の 3 層ファイル検証。Content-Length と実測サイズ両方で 50 MB 制限（スプーフィング対策）。" },
        ],
      },

      teamEmpo: {
        subtitle: "AI-Powered PR Planning Recommender",
        description: "企業の広報担当者が抱える「次に何を発信すればよいか分からない」という課題を解決する、プレスリリース企画の提案ダッシュボード。企業情報・過去のプレスリリース・閲覧数・キーワードを分析し、「過去の発信の再活用（続報・インタビュー・開発背景）」と「これまで発信していない切り口（企業文化・働く人・仕事の進め方）」の2方向から具体的な企画を提案します。最終投稿日からの経過日数に応じて優先する企画を自動判定し、普段使うダッシュボード上から自然に提案を確認できるUIを実装しました。PR TIMES ハッカソンに3人チームで参加し、最優秀チーム賞を受賞した作品です。",
        statusBadge: "Hackathon",
        awardBadge: "最優秀チーム賞",
        roleBadge: "3人チーム開発",
        featuresLabel: "主な機能",
        features: [
          "過去のプレスリリースをもとにした企画提案",
          "未発信ジャンルから企業の新しい魅力を発見",
          "OpenAI APIによる構造化された企画文の生成",
          "Embeddingとコサイン類似度による参考記事の抽出・提案順位の決定",
          "文体・想定読者・発信目的などを指定した再生成",
          "選択した記事・企画だけの個別再生成",
          "生成履歴の保存・復元と提案キャッシュ",
          "企業検索・投稿停止企業・中小企業規模などによる絞り込み",
          "API未設定時や生成失敗時のテンプレート提案へのフォールバック",
          "PC・スマートフォンに対応したレスポンシブUI",
        ],
        techLabel: "技術スタック",
        techStack: [
          { layer: "Frontend",   tech: "React 19 + TypeScript + Vite" },
          { layer: "Backend",    tech: "Node.js + Express 5 (TypeScript)" },
          { layer: "検証/テスト", tech: "Zod + Node.js Test Runner" },
          { layer: "DB",         tech: "PostgreSQL 16（マイグレーション運用）" },
          { layer: "企画生成",   tech: "OpenAI Responses API" },
          { layer: "類似度",     tech: "OpenAI Embeddings + コサイン類似度" },
          { layer: "インフラ",   tech: "Docker Compose + Nginx" },
          { layer: "デプロイ",   tech: "AWS EC2 + Amazon RDS" },
        ],
        pipelineLabel: "提案生成パイプライン",
        pipeline: [
          { label: "企業・過去記事",   color: "#10b981" },
          { label: "閲覧数/キーワード分析" },
          { label: "Embedding類似度" },
          { label: "OpenAI生成" },
          { label: "経過日数で優先度判定" },
          { label: "ダッシュボード提案", color: "#fbbf24" },
        ],
        detailsLabel: "工夫したポイント",
        details: [
          { title: "データに基づく提案", desc: "生成AIに企画を自由に考えさせるだけでなく、企業の過去記事・閲覧実績・キーワード・他社事例を入力として使用。提案の着想元となった記事も確認できるため、広報担当者が企画の根拠を判断しやすい設計にしました。" },
          { title: "既存業務への自然な組み込み", desc: "専用の分析画面を探さなくても、PR TIMES 風ダッシュボードの上部に最有力企画を表示。詳細を見たい場合だけレコメンド画面へ移動できる、利用負担の少ない導線にしました。" },
          { title: "AIに依存しすぎない設計", desc: "OpenAI API が利用できない場合や生成に失敗した場合でも、実データからテンプレート形式の提案を作成します。生成結果は PostgreSQL へ保存・キャッシュし、表示速度と API 利用コストにも配慮しています。" },
        ],
      },

      secureCodeArena: {
        subtitle: "Gamified Secure Coding Arena",
        description: "意図的に脆弱性を仕込んだWebアプリに対し、ユーザーがpatchを提出するとサーバー側の攻撃エンジンが「修正前は攻撃成功 / 修正後は失敗」を自動検証して合否を判定する、ゲーミフィケーション型のセキュアコーディング学習プラットフォーム。4人チームによるハッカソン発のプロジェクト。",
        demoNote: "※ Demo（Xserver VPS 上で稼働）: Google アカウントでログインしてすぐ試せます。全 12 問すべてで実際に Docker を起動し、攻撃エンジンによる自動攻撃で patch 適用前後の挙動を検証して採点します。",
        roleLabel: "担当・取り組み",
        roleBadge: "バックエンド・サーバー担当",
        tasks: [
          "Node.js (Express) によるオーケストレーターAPI設計・実装",
          "Docker / docker-compose で脆弱アプリを隔離コンテナ起動",
          "unified diff patchの検証フロー（`git apply --check` → 適用 → 再起動 → ヘルスチェック）",
          "攻撃エンジン制御：patch適用前後で攻撃を流して自動採点",
          "コンテナのセキュリティ境界設計（read-only / memory 256MB / CPU 0.5 / iptables遮断）",
          "脆弱アプリ側の問題セット（SQLi / XSS / IDOR 等）の整備",
          "全 12 問すべてを攻撃エンジンで自動攻撃・自動採点できるよう対応",
          "認証をメールアドレスログインから Google ログイン（OAuth）へ移行",
          "Xserver VPS 上で本番デプロイ・公開運用（https://securecodearena.xvps.jp/ として公開）",
        ],
        techLabel: "バックエンド技術スタック",
        techStack: [
          { layer: "Web API",    tech: "Node.js (Express) オーケストレーター" },
          { layer: "実行環境",   tech: "Docker / docker-compose（問題毎に隔離）" },
          { layer: "Patch検証", tech: "git apply --check + コンテナ内適用" },
          { layer: "攻撃エンジン", tech: "Exploit Runner（HTTP/SQLi/XSS等）" },
          { layer: "隔離境界",   tech: "read-only FS / mem 256MB / CPU 0.5 / iptables" },
          { layer: "ヘルス",     tech: "再起動 + ヘルスチェックゲート" },
          { layer: "問題セット", tech: "脆弱Webアプリ（Node/PHP 等）× 12 問" },
          { layer: "認証",       tech: "Google ログイン（OAuth）" },
          { layer: "デプロイ",   tech: "Xserver VPS（securecodearena.xvps.jp）" },
          { layer: "連携先",     tech: "Next.js 16 + Monaco Editor フロントエンド" },
        ],
        pipelineLabel: "採点パイプライン",
        pipeline: [
          { label: "Patch提出",     color: "#f43f5e" },
          { label: "git apply --check" },
          { label: "Pre-Attack" },
          { label: "Patch適用" },
          { label: "再起動 + Health" },
          { label: "Post-Attack" },
          { label: "合否判定",      color: "#34d399" },
        ],
        vulnLabel: "収録している脆弱性カテゴリ",
        vulnerabilities: [
          "SQL Injection（ログインフォーム）",
          "XSS（コメント機能）",
          "CSRF（送金フロー）",
          "IDOR（プロフィール閲覧）",
          "Open Redirect",
          "ハードコードされたシークレット",
          "ファイルアップロードの不備",
          "コマンドインジェクション（ping機能）",
        ],
        detailsLabel: "実装の工夫",
        details: [
          { title: "全 12 問を実挙動ベースで自動採点", desc: "正規表現的な文字列マッチではなく、攻撃エンジンを使って patch 適用前後の両方に同じ攻撃を流し、「適用前 exploited=true / 適用後 exploited=false」を満たした場合のみ合格と判定。収録している 12 問すべてでこの自動攻撃による検証に対応し、'本当に直っているか' を実挙動で確認できるようにした。" },
          { title: "ホスト側RCE対策の多層防御", desc: "ユーザー提出物を unified diff (patch) 形式に限定し、`git apply --check` で構文・適用可否を事前検証。さらに各問題は read-only FS / メモリ 256MB / CPU 0.5 の隔離コンテナで実行し、iptables で外部通信を遮断してホスト側での任意コード実行を防止。" },
          { title: "問題ごとの独立コンテナ + ヘルスチェック", desc: "各脆弱アプリは問題ごとに独立した Docker コンテナで起動。patch 適用後は再起動 → ヘルスチェックで「アプリが壊れていないこと」を確認してから攻撃エンジンを実行し、誤判定を防ぐ。" },
          { title: "脆弱性カタログの設計", desc: "SQLi / XSS / CSRF / IDOR / Open Redirect / コマンドインジェクションなど OWASP 系の代表的な脆弱性を、最小構成の脆弱 Web アプリとしてカタログ化。学習者が「攻撃される様子」と「直すべき箇所」を短いコードで体感できる粒度に整える。" },
        ],
      },

      smartSchedule: {
        subtitle: "AI-Powered Smart Scheduler for Students",
        description: "大学生向けのAIスケジュール管理アプリ。Google OAuth でログインし、Google Classroom の課題を自動取り込み・空き時間を検出して Google Calendar に自動スケジュール。スキル診断クイズでバッファ時間を最適化し、乗換案内による遅延検知・リスケ提案も実装予定。",
        statusBadge: "一時中断中",
        roleBadge: "個人開発",
        techLabel: "技術スタック",
        techStack: [
          { layer: "Frontend", tech: "Next.js 14 App Router" },
          { layer: "言語",     tech: "TypeScript" },
          { layer: "UI",       tech: "Tailwind CSS + shadcn/ui" },
          { layer: "Auth",     tech: "NextAuth.js (Google OAuth)" },
          { layer: "DB",       tech: "Supabase (PostgreSQL + RLS)" },
          { layer: "外部API",  tech: "Calendar / Classroom / Directions" },
          { layer: "PWA",      tech: "Service Worker + オフラインキャッシュ" },
          { layer: "Deploy",   tech: "Vercel" },
        ],
        dataFlowLabel: "データフロー",
        dataFlow: [
          { label: "Google OAuth",  color: "#06b6d4" },
          { label: "Classroom取込" },
          { label: "スキル診断" },
          { label: "空き時間検出" },
          { label: "AI最適化" },
          { label: "Calendar書込",  color: "#34d399" },
        ],
        featuresLabel: "主な機能",
        features: [
          "Google OAuth + Calendar / Classroom 連携",
          "スキル診断クイズ（30問）でバッファ倍率を自動計算",
          "空き時間検出 → カレンダー自動スケジュール",
          "Google Directions API で通勤ルート・遅延検知",
          "PWA対応・ダークモード・タイムライン表示",
        ],
        detailsLabel: "設計の工夫",
        details: [
          { title: "スキル診断によるパーソナライズ", desc: "30問のクイズで集中持続力・先延ばし傾向・作業スピードを数値化。課題カテゴリ別にバッファ倍率（1.0×〜2.5×）を自動算出し、個人差を考慮したスケジュールを生成。" },
          { title: "空き時間検出アルゴリズム",       desc: "Google Calendar API の既存イベントを解析してフリースロットを抽出。課題の優先度・推定所要時間・締切を考慮し、最も適した時間帯へ自動挿入。リスケ時も同アルゴリズムで再配置。" },
          { title: "Supabase RLS でマルチテナント設計", desc: "全テーブルに Row Level Security ポリシーを適用し、user_id フィルタで DB レベルのデータ分離を保証。NextAuth のセッションと Supabase の JWT を連携して認証フローを一元化。" },
          { title: "遅延検知 + 自動リスケ",           desc: "Google Directions API のリアルタイム所要時間と通常所要時間を比較し、遅延を検知。影響を受ける当日のスケジュールを自動で再計算し、プッシュ通知で提案。" },
        ],
      },
    },

    skills: {
      label: "SKILLS & LANGUAGES",
      heading: "スキルと技術スタック",
      subheading: "現在使える技術と学習中の領域",
      categories: [
        { title: "Languages",    color: "#818cf8", items: [
          { name: "Java",            note: "メイン言語", level: 4 },
          { name: "Python",          note: "基礎",       level: 2 },
          { name: "TypeScript / JS", note: "基礎",       level: 2 },
          { name: "VBA",             note: "教材制作",   level: 3 },
          { name: "HTML / CSS",      note: null,         level: 2 },
        ]},
        { title: "Frameworks",   color: "#a78bfa", items: [
          { name: "FastAPI",         note: null,         level: 3 },
          { name: "Next.js",         note: "App Router", level: 3 },
          { name: "scikit-learn",    note: null,         level: 2 },
          { name: "React",           note: "基礎",       level: 2 },
          { name: "Tailwind CSS",    note: "基礎",       level: 2 },
        ]},
        { title: "AI / Audio",   color: "#c084fc", items: [
          { name: "機械学習",        note: "分類・回帰", level: 2 },
          { name: "WORLD / pyworld",  note: "F0抽出",     level: 3 },
          { name: "MelBandRoformers", note: "音源分離",  level: 3 },
          { name: "音声信号処理",    note: null,         level: 2 },
        ]},
        { title: "Security",     color: "#22d3ee", items: [
          { name: "サイバーセキュリティ", note: "学習中", level: 1 },
          { name: "ネットワーク基礎",    note: null,     level: 2 },
        ]},
        { title: "Tools & Infra", color: "#34d399", items: [
          { name: "Git / GitHub",    note: "チーム開発",       level: 3 },
          { name: "Supabase",        note: "PostgreSQL / RLS", level: 3 },
          { name: "AWS",             note: "勉強中",           level: 1 },
          { name: "Google Cloud",    note: "勉強中",           level: 1 },
          { name: "Linux / CLI",     note: null,               level: 2 },
        ]},
        { title: "Other / Lang", color: "#fbbf24", items: [
          { name: "英語",            note: "TOEIC 750 / 英検2級", level: 3 },
          { name: "教材設計",        note: "VBAカリキュラム",      level: 3 },
          { name: "チーム開発",      note: "5人チーム",            level: 3 },
        ]},
      ],
    },

    contact: {
      label: "CONTACT",
      heading: "お問い合わせ",
      subheading: "インターンシップのご検討やお仕事のご依頼がございましたら、ぜひご連絡ください。",
      nameLabel: "お名前",
      namePlaceholder: "山田 太郎",
      emailLabel: "メールアドレス",
      messageLabel: "メッセージ",
      messagePlaceholder: "ご用件をお書きください...",
      send: "送信する",
      sending: "送信中...",
      success: "送信しました！お返事をお待ちください。",
      sendAgain: "もう一度送る",
      error: "送信に失敗しました。メールで直接ご連絡ください。",
      sendEmail: "メールを送る",
      copyEmail: "メールアドレスをコピー",
    },
  },

  en: {
    lang: "JA",
    nav: {
      about: "About",
      timeline: "Timeline",
      projects: "Projects",
      skills: "Skills",
      contact: "Contact",
    },
    banner: "Seeking internship opportunities in Backend / ML / Security",
    bannerClose: "Close",
    backToTop: "Back to top",

    hero: {
      badge: "Looking for internships",
      description: "3rd-year CS student | Aspiring backend engineer | Interested in Cybersecurity × Machine Learning",
      yearBadge: "3rd Year",
      locationBadge: "Osaka",
      projectsBtn: "Projects →",
      contactBtn: "Contact",
    },

    about: {
      label: "ABOUT",
      heading: "About Me",
      subheading: "Kindai University student interested in Backend / Security / ML",
      paragraphs: [
        "I enrolled in the Faculty of Informatics at Kindai University in 2024 and am currently in my third year. Since elementary school, I've been involved in programming and data analysis through e-kagaku, and I'm currently interested in backend engineering, cybersecurity, and machine learning.",
        "I'm developing 'Pitch Scout,' an AI-powered vocal range analysis app for karaoke, in a team setting, handling the backend and ML model. I recently won the Kindai Innovation Award at 'Kindai Hackathon 2025,' and have gained development experience at external events like KC3Hack.",
        "I'm continuously working on improving my English. Currently, I teach programming to elementary and high school students at e-kagaku, while seeking internships in backend, security, and AI/ML to gain real-world experience and product knowledge.",
      ],
      cards: [
        { label: "Education", value: "Kindai University, Informatics" },
        { label: "Location",  value: "Osaka, Japan" },
        { label: "Interests", value: "Security / ML / Backend" },
        { label: "Status",    value: "Seeking Internship" },
        { label: "Award",     value: "Kindai Innovation Award '25" },
      ],
    },

    timeline: {
      label: "TIMELINE",
      heading: "Timeline",
      subheading: "Learning & development history",
      items: [
        { year: "2015.10", title: "Started Learning Programming",           desc: "Joined e-kagaku and began learning programming fundamentals and hardware creation using e-gadget." },
        { year: "2019.xx", title: "Lake Biwa Environmental Project",        desc: "Participated in an environmental data collection and analysis project at e-kagaku." },
        { year: "2020.xx", title: "Stratosphere Exploration & Data Analysis", desc: "Joined a stratosphere exploration project using everyday items and MATLAB. Gained hands-on experience with hardware and data analysis." },
        { year: "2024.03", title: "Graduated from e-kagaku",               desc: "Completed basic and advanced courses. Acquired machine learning skills using Arduino, VBA, and MATLAB." },
        { year: "2024.04", title: "Enrolled at Kindai University",          desc: "Enrolled in the Faculty of Informatics. Began more specialized study in CS and information engineering." },
        { year: "2024.05", title: "Became e-kagaku Supporter",              desc: "Started mentoring the next generation of students as an e-kagaku supporter." },
        { year: "2025.12", title: "Won Award at Kindai Hackathon",          desc: "Won the 'Kindai Innovation Award' at the university-wide hackathon." },
        { year: "2026.02", title: "KC3Hack / Pitch Scout Development",      desc: "Participated in KC3Hack, the largest student hackathon in Kansai. Developed 'Pitch Scout,' a vocal range analysis app for karaoke, with a 5-person team—handling the backend audio processing pipeline and the chest/falsetto voice classification ML model." },
        { year: "2026.05", title: "Participated in Geikuhaku (技育博)",      desc: "Joined Geikuhaku on May 30 — a tech exhibition for student engineers hosted by Supporterz. Showcased team-built products and exchanged feedback on development workflows and product design with engineers from other universities." },
        { year: "2026.06", title: "58Hack / OB Award",                       desc: "Participated in the '58Hack' hackathon on June 14 and received the OB Award." },
        { year: "2026.08", title: "Creationline 5-Day Internship",            desc: "Attended the 5-day summer internship at Creationline, Inc. (Aug 3-7)." },
        { year: "2026.08", title: "PR TIMES Hackathon / Best Team Award",      desc: "Participated in the PR TIMES hackathon (Aug 12-14). Built 'Team Empo,' a PR planning recommendation service, with a 3-person team and won the Best Team Award." },
        { year: "2026.08", title: "Works Applications 6-Day Internship",       desc: "Attended the 6-day internship at Works Applications (Aug 23-28)." },
        { year: "2026.09", title: "ITEC Hankyu Hanshin 5-Day Internship",     desc: "Attended the 5-day internship at ITEC Hankyu Hanshin Co., Ltd. (Aug 31 - Sep 4)." },
      ],
    },

    projects: {
      label: "PROJECTS",
      heading: "Projects",
      subheading: "Products I've designed, implemented, or am currently developing",
      accordionOpen: "Close",
      accordionClosed: "Show Details",

      pitchScout: {
        subtitle: "AI-Powered Karaoke Song Recommender",
        description: "A web app that analyzes vocal range from a short recording and recommends matching karaoke songs using AI. Developed in a 5-person team, primarily responsible for the backend audio processing pipeline and ML model.",
        roleLabel: "Responsibilities",
        roleBadge: "Backend / ML",
        tasks: [
          "Built vocal separation pipeline using MelBandRoformers",
          "F0 / spectral feature extraction with WORLD (pyworld)",
          "Designed AP/HNR gate + RandomForest chest/falsetto classifier",
          "Designed and implemented backend API with FastAPI",
          "Multi-stage noise removal with DeepFilterNet + Silero VAD",
        ],
        techLabel: "Backend Tech Stack",
        techStack: [
          { layer: "Web API",     tech: "FastAPI 0.115 + uvicorn" },
          { layer: "F0 Extract",  tech: "WORLD (pyworld)" },
          { layer: "Src. Sep.",   tech: "MelBandRoformers (audio-separator)" },
          { layer: "Denoising",   tech: "DeepFilterNet3 + Silero VAD" },
          { layer: "ML Infer.",   tech: "scikit-learn RandomForest" },
          { layer: "Audio Proc.", tech: "soundfile / numpy / ffmpeg" },
          { layer: "Song DB",     tech: "SQLite (~5,000 songs / ~850 artists)" },
          { layer: "User DB",     tech: "Supabase (PostgreSQL)" },
        ],
        pipelineLabel: "Audio Analysis Pipeline",
        pipeline: [
          { label: "Audio Input",       color: "#818cf8" },
          { label: "ffmpeg Convert" },
          { label: "MelBandRoformers" },
          { label: "DeepFilterNet" },
          { label: "WORLD Extract" },
          { label: "ML Infer." },
          { label: "Song Recommend",    color: "#34d399" },
        ],
        detailsLabel: "Implementation Highlights",
        details: [
          { title: "Gate-first Hybrid Chest/Falsetto Detection", desc: "Uses AP (aperiodicity) and HNR (harmonics-to-noise ratio) as gate conditions: both satisfied → falsetto confirmed; one-sided → falls back to RandomForest inference. Hard floor at F0 < 330 Hz always classifies as chest voice." },
          { title: "WORLD Features + 20-dim Segment Aggregation", desc: "Extracts F0 / spectral envelope (SP) / aperiodicity (AP) via pyworld. Computes 9-dim frame acoustic features (f0, ap_mean, hnr, sp_tilt, h1_h2, hcount, etc.) then aggregates into 20-dim segment features. Estimates chest confidence via StandardScaler + RandomForest pipeline." },
          { title: "Multi-stage Noise Removal Pipeline", desc: "Removes residual noise after MelBandRoformers separation via: ① DeepFilterNet3 (NN-based, 20 dB attenuation limit), ② Silero VAD (excludes singing score < 0.3, with safeguards against over-removing falsetto), ③ noisereduce fallback." },
          { title: "3-Layer Security Validation",      desc: "Three-layer file validation: extension → MIME type → magic bytes (WAV: RIFF+WAVE double-check). 50 MB limit enforced via both Content-Length and actual measured size (anti-spoofing)." },
        ],
      },

      teamEmpo: {
        subtitle: "AI-Powered PR Planning Recommender",
        description: "A press-release planning dashboard that answers the question PR teams struggle with most: 'what should we publish next?' It analyzes company profiles, past press releases, view counts, and keywords, then proposes concrete plans from two angles — reusing past coverage (follow-ups, interviews, behind-the-scenes) and untapped angles (company culture, the people, how the work gets done). Plans are auto-prioritized by how long it has been since the last post, and surfaced right on the dashboard PR staff already use. Built by a 3-person team at the PR TIMES hackathon, where it won the Best Team Award.",
        statusBadge: "Hackathon",
        awardBadge: "Best Team Award",
        roleBadge: "3-Person Team",
        featuresLabel: "Key Features",
        features: [
          "Plan proposals grounded in the company's past press releases",
          "Surfaces new angles from genres the company has never covered",
          "Structured plan copy generated via the OpenAI API",
          "Embedding + cosine similarity to pick reference articles and rank proposals",
          "Regeneration with tone, target reader, and publishing goal specified",
          "Per-item regeneration for a single selected article or plan",
          "Generation history saving / restore plus proposal caching",
          "Filtering by company search, inactive publishers, and SME size",
          "Template-based fallback when the API is unset or generation fails",
          "Responsive UI for both desktop and mobile",
        ],
        techLabel: "Tech Stack",
        techStack: [
          { layer: "Frontend",   tech: "React 19 + TypeScript + Vite" },
          { layer: "Backend",    tech: "Node.js + Express 5 (TypeScript)" },
          { layer: "Validation", tech: "Zod + Node.js Test Runner" },
          { layer: "DB",         tech: "PostgreSQL 16 (with migrations)" },
          { layer: "Generation", tech: "OpenAI Responses API" },
          { layer: "Similarity", tech: "OpenAI Embeddings + cosine similarity" },
          { layer: "Infra",      tech: "Docker Compose + Nginx" },
          { layer: "Deploy",     tech: "AWS EC2 + Amazon RDS" },
        ],
        pipelineLabel: "Proposal Generation Pipeline",
        pipeline: [
          { label: "Company & Past PR", color: "#10b981" },
          { label: "Views / Keywords" },
          { label: "Embedding Similarity" },
          { label: "OpenAI Generation" },
          { label: "Recency Priority" },
          { label: "Dashboard Proposal", color: "#fbbf24" },
        ],
        detailsLabel: "Implementation Highlights",
        details: [
          { title: "Data-Grounded Proposals", desc: "Rather than letting the model invent plans freely, the company's past articles, view performance, keywords, and peer examples are fed in as input. The source article behind each idea stays visible, so PR staff can judge the reasoning behind a proposal." },
          { title: "Fits Into Existing Workflow", desc: "No separate analytics screen to hunt for — the strongest plan is shown at the top of a PR TIMES-style dashboard, and users only move to the recommendation screen when they want the details." },
          { title: "Not Over-Reliant on AI", desc: "When the OpenAI API is unavailable or generation fails, template-based proposals are still built from real data. Generated results are stored and cached in PostgreSQL, keeping both render speed and API cost in check." },
        ],
      },

      secureCodeArena: {
        subtitle: "Gamified Secure Coding Arena",
        description: "A gamified secure-coding platform where users submit patches to fix vulnerable web apps. The server-side attack engine automatically validates 'exploit succeeds before / fails after the patch' to grade submissions. Built by a 4-person team as a hackathon project.",
        demoNote: "Demo note (running on an Xserver VPS): sign in with a Google account to try it right away. All 12 challenges now spin up Docker for real and are graded by the attack engine, which runs the exploit before and after the patch.",
        roleLabel: "Responsibilities",
        roleBadge: "Backend / Server",
        tasks: [
          "Designed and built the orchestrator API in Node.js (Express)",
          "Isolated each vulnerable app in its own Docker / docker-compose container",
          "Patch validation flow: `git apply --check` → apply → restart → health check",
          "Drove the attack engine to grade submissions by pre/post patch exploit outcome",
          "Designed container security boundary (read-only / 256 MB / 0.5 CPU / iptables egress block)",
          "Authored the vulnerable challenge set (SQLi / XSS / IDOR, etc.)",
          "Extended automated exploit-based grading to cover all 12 challenges",
          "Migrated authentication from email login to Google login (OAuth)",
          "Deployed and operated the production instance on an Xserver VPS (published at https://securecodearena.xvps.jp/)",
        ],
        techLabel: "Backend Tech Stack",
        techStack: [
          { layer: "Web API",     tech: "Node.js (Express) Orchestrator" },
          { layer: "Runtime",     tech: "Docker / docker-compose (per-problem)" },
          { layer: "Patch Check", tech: "git apply --check + in-container apply" },
          { layer: "Attack Eng.", tech: "Exploit Runner (HTTP / SQLi / XSS, etc.)" },
          { layer: "Isolation",   tech: "read-only FS / 256 MB / 0.5 CPU / iptables" },
          { layer: "Health",      tech: "Restart + health-check gate" },
          { layer: "Challenges",  tech: "12 vulnerable web apps (Node / PHP, etc.)" },
          { layer: "Auth",        tech: "Google login (OAuth)" },
          { layer: "Deploy",      tech: "Xserver VPS (securecodearena.xvps.jp)" },
          { layer: "Frontend",    tech: "Next.js 16 + Monaco Editor (linked)" },
        ],
        pipelineLabel: "Grading Pipeline",
        pipeline: [
          { label: "Submit Patch",   color: "#f43f5e" },
          { label: "git apply --check" },
          { label: "Pre-Attack" },
          { label: "Apply Patch" },
          { label: "Restart + Health" },
          { label: "Post-Attack" },
          { label: "Verdict",        color: "#34d399" },
        ],
        vulnLabel: "Covered Vulnerability Categories",
        vulnerabilities: [
          "SQL Injection (login form)",
          "XSS (comment feature)",
          "CSRF (money transfer flow)",
          "IDOR (profile access)",
          "Open Redirect",
          "Hardcoded secrets",
          "Insecure file upload",
          "Command injection (ping feature)",
        ],
        detailsLabel: "Implementation Highlights",
        details: [
          { title: "Behavior-based Auto Grading Across All 12 Challenges", desc: "Instead of regex-style string matching, the same attack is run by the exploit engine both before and after the patch. A submission only passes when 'exploited=true before / exploited=false after' is satisfied. All 12 challenges in the catalog now support this automated attack flow, so every fix is verified at runtime." },
          { title: "Defense-in-Depth Against Host RCE", desc: "User submissions are restricted to unified-diff patches and pre-validated with `git apply --check`. Each problem runs in an isolated container with a read-only FS, 256 MB memory, 0.5 CPU, and iptables-blocked egress — preventing arbitrary code execution from reaching the host." },
          { title: "Per-Problem Containers + Health Check", desc: "Each vulnerable app runs in its own Docker container. After applying a patch, the orchestrator restarts and health-checks the app to confirm it isn't broken before invoking the attack engine, avoiding false verdicts." },
          { title: "Vulnerability Challenge Catalog", desc: "Cataloged representative OWASP-style flaws (SQLi / XSS / CSRF / IDOR / Open Redirect / command injection) as minimal vulnerable web apps. Each challenge is tight enough that learners can both see the exploit happen and clearly identify what to fix in code." },
        ],
      },

      smartSchedule: {
        subtitle: "AI-Powered Smart Scheduler for Students",
        description: "An AI-powered schedule management app for university students. Users log in with Google OAuth, automatically import Google Classroom assignments, detect free slots, and schedule tasks to Google Calendar. Optimizes buffer time via a skill assessment quiz, with planned train delay detection and auto-rescheduling.",
        statusBadge: "On Hold",
        roleBadge: "Solo Project",
        techLabel: "Tech Stack",
        techStack: [
          { layer: "Frontend", tech: "Next.js 14 App Router" },
          { layer: "Language", tech: "TypeScript" },
          { layer: "UI",       tech: "Tailwind CSS + shadcn/ui" },
          { layer: "Auth",     tech: "NextAuth.js (Google OAuth)" },
          { layer: "DB",       tech: "Supabase (PostgreSQL + RLS)" },
          { layer: "APIs",     tech: "Calendar / Classroom / Directions" },
          { layer: "PWA",      tech: "Service Worker + Offline Cache" },
          { layer: "Deploy",   tech: "Vercel" },
        ],
        dataFlowLabel: "Data Flow",
        dataFlow: [
          { label: "Google OAuth",       color: "#06b6d4" },
          { label: "Import Classroom" },
          { label: "Skill Assessment" },
          { label: "Free Slot Detection" },
          { label: "AI Optimization" },
          { label: "Write to Calendar",  color: "#34d399" },
        ],
        featuresLabel: "Key Features",
        features: [
          "Google OAuth + Calendar / Classroom integration",
          "Skill quiz (30 questions) auto-calculates buffer multiplier",
          "Free slot detection → auto-schedule to Google Calendar",
          "Google Directions API for commute routes & delay detection",
          "PWA support · Dark mode · Timeline view",
        ],
        detailsLabel: "Design Highlights",
        details: [
          { title: "Personalization via Skill Assessment",  desc: "30-question quiz quantifies focus duration, procrastination tendency, and work speed. Automatically calculates buffer multiplier (1.0×–2.5×) per assignment category, accounting for individual differences." },
          { title: "Free Slot Detection Algorithm",         desc: "Analyzes existing Google Calendar events to extract free slots. Considers assignment priority, estimated duration, and deadlines to auto-insert tasks into the best time slot. Same algorithm reused for rescheduling." },
          { title: "Multi-tenant Design with Supabase RLS", desc: "Row Level Security policies applied to all tables, guaranteeing DB-level data isolation via user_id filter. NextAuth session and Supabase JWT linked to centralize the authentication flow." },
          { title: "Delay Detection + Auto Reschedule",     desc: "Compares real-time Google Directions API travel time with normal travel time to detect delays. Automatically recalculates the affected day's schedule and suggests changes via push notification." },
        ],
      },
    },

    skills: {
      label: "SKILLS & LANGUAGES",
      heading: "Skills & Tech Stack",
      subheading: "Technologies I can use and areas I'm currently learning",
      categories: [
        { title: "Languages",    color: "#818cf8", items: [
          { name: "Java",            note: "Main",         level: 4 },
          { name: "Python",          note: "Basics",       level: 2 },
          { name: "TypeScript / JS", note: "Basics",       level: 2 },
          { name: "VBA",             note: "Course Dev.",  level: 3 },
          { name: "HTML / CSS",      note: null,           level: 2 },
        ]},
        { title: "Frameworks",   color: "#a78bfa", items: [
          { name: "FastAPI",         note: null,           level: 3 },
          { name: "Next.js",         note: "App Router",   level: 3 },
          { name: "scikit-learn",    note: null,           level: 2 },
          { name: "React",           note: "Basics",       level: 2 },
          { name: "Tailwind CSS",    note: "Basics",       level: 2 },
        ]},
        { title: "AI / Audio",   color: "#c084fc", items: [
          { name: "Machine Learning",       note: "Class./Regr.", level: 2 },
          { name: "WORLD / pyworld",          note: "F0 Extraction", level: 3 },
          { name: "MelBandRoformers",        note: "Src. Sep.",    level: 3 },
          { name: "Audio Signal Processing", note: null,          level: 2 },
        ]},
        { title: "Security",     color: "#22d3ee", items: [
          { name: "Cybersecurity",          note: "Learning",     level: 1 },
          { name: "Network Fundamentals",   note: null,           level: 2 },
        ]},
        { title: "Tools & Infra", color: "#34d399", items: [
          { name: "Git / GitHub",    note: "Team Dev.",        level: 3 },
          { name: "Supabase",        note: "PostgreSQL / RLS", level: 3 },
          { name: "AWS",             note: "Learning",         level: 1 },
          { name: "Google Cloud",    note: "Learning",         level: 1 },
          { name: "Linux / CLI",     note: null,               level: 2 },
        ]},
        { title: "Other / Lang", color: "#fbbf24", items: [
          { name: "English",         note: "TOEIC 750 / Eiken 2", level: 3 },
          { name: "Course Design",   note: "VBA Curriculum",      level: 3 },
          { name: "Team Dev.",       note: "5-person team",        level: 3 },
        ]},
      ],
    },

    contact: {
      label: "CONTACT",
      heading: "Contact",
      subheading: "Feel free to reach out for internship opportunities or project inquiries.",
      nameLabel: "Name",
      namePlaceholder: "John Doe",
      emailLabel: "Email Address",
      messageLabel: "Message",
      messagePlaceholder: "Write your message here...",
      send: "Send",
      sending: "Sending...",
      success: "Message sent! I'll get back to you soon.",
      sendAgain: "Send another",
      error: "Failed to send. Please contact me directly via email.",
      sendEmail: "Send Email",
      copyEmail: "Copy email address",
    },
  },
};

export default translations;
